import { Container, Box, Typography, Button } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ProjectsSection } from "../Components/ProjectSection";

const Projects = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="lg">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/profile")}
          sx={{
            mb: 3,
            textTransform: "none",
            fontWeight: 600,
            color: "#1976d2"
          }}
        >
          Back to Profile
        </Button>
        
        <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
          All Projects
        </Typography>
        
        <ProjectsSection limit={null} />
      </Container>
    </Box>
  );
};

export default Projects;